<template>
  <div class="p-4">
    <div class="loader-overlay" v-if="isDataFetch">
      <b-spinner
        style="width: 3rem; height: 3rem"
        type="grow"
        class="text-white"
      ></b-spinner>
    </div>
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-6 text-left">
            <h4>Car list</h4>
          </div>
          <div class="col-6 text-right">
            <button class="btn btn-sm btn-primary" @click="fnGoNewCars()">
              New
            </button>
          </div>
        </div>
      </div>

      <div class="card-body">
        <div class="search-row mb-3">
          <div class="form-group search-box item mb-0">
            <label for="paginate" class="mb-0">Search</label>
            <input
              v-model="q"
              type="search"
              class="form-control"
              placeholder="Search ..."
              @keyup.enter="fnSearch()"
            />
          </div>
          <div class="status-box item">
            <label for="paginate" class="mb-0">Status</label>
            <select
              v-model="selectedStatus"
              class="form-control sits_select"
              @change="fnSearch()"
            >
              <option value="">All Status</option>
              <option value="1">Active</option>
              <option value="0">In-active</option>
            </select>
          </div>

          <div class="item">
            <button class="btn btn-sm btn-primary mt-4" @click="fnSearch()">
              Search
            </button>
          </div>
          <div class="item">
            <button class="btn btn-sm btn-primary mt-4" @click="fnClear()">
              Clear
            </button>
          </div>
        </div>
        <div class="table-responsive table-sm tableCarsList">
          <table
            class="
              v-datatable-light
              table table-bordered table-hover table-striped table-center
            "
          >
            <thead>
              <tr>
                <th class="header-item header-column-0"></th>
                <th class="header-item header-column-c">
                  <a href="#" @click.prevent="fnChangeSort('id')">Car Id</a>
                  <span v-if="sort_direction == 'desc' && sort_field == 'id'"
                    >&uarr;</span
                  >
                  <span v-if="sort_direction == 'asc' && sort_field == 'id'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item header-column-c">
                  <a
                    href="#"
                    @click.prevent="fnChangeSort('mainCarDescription')"
                    >Main Car Description</a
                  >
                  <span
                    v-if="
                      sort_direction == 'desc' &&
                      sort_field == 'mainCarDescription'
                    "
                    >&uarr;</span
                  >
                  <span
                    v-if="
                      sort_direction == 'asc' &&
                      sort_field == 'mainCarDescription'
                    "
                    >&darr;</span
                  >
                </th>
                <th class="header-item header-column-c">Category</th>
                <th class="header-item header-column-c">Weekly Cost ($)</th>
                <th class="header-item header-column-c">
                  Drive Away Price ($)
                </th>
                <th class="header-item header-column-c">Range</th>
                <th class="header-item header-column-c">Power (KW)</th>

                <th class="header-item header-column-c">ANCAP Safety Rating</th>
                <th class="header-item header-column-c9">Performance</th>

                <th class="header-item header-column-c">
                  <a href="#" @click.prevent="fnChangeSort('status')">Status</a>
                  <span
                    v-if="sort_direction == 'desc' && sort_field == 'status'"
                    >&uarr;</span
                  >
                  <span v-if="sort_direction == 'asc' && sort_field == 'status'"
                    >&darr;</span
                  >
                </th>

                <th class="header-item header-column-c">Actions</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(row, index) in getCarsPaginateData.data">
                <tr :key="(row, index)">
                  <td
                    class="column-0"
                    @click="toggle(index)"
                    :class="{ opened: opened.includes(index) }"
                  >
                    <span class="text-info pl-2"
                      ><i class="fas fa-outdent"></i
                    ></span>
                  </td>
                  <td class="column-1">{{ row.id }}</td>
                  <td class="column-2">{{ row.mainCarDescription }}</td>

                  <td class="column-3">{{ row.carCategoryName }}</td>
                  <td class="column-r">
                    {{ row.weeklyCost }}
                  </td>
                  <td class="column-r">
                    {{ row.driveAwayPrice }}
                  </td>
                  <td class="column-r">
                    {{ row.rangeFrom }}
                  </td>
                  <td class="column-r">
                    {{ row.powerKW }}
                  </td>

                  <td class="column-r">
                    {{ row.ANCAPSafetyRating }}
                  </td>

                  <td class="column-r">
                    {{ row.performance }}
                  </td>

                  <td class="column-c">
                    <div v-if="row.status == 0">
                      <span class="badge bdg-draft">In-active</span>
                    </div>
                    <div v-if="row.status == 1">
                      <span class="badge bdg-submitted">Active</span>
                    </div>
                  </td>

                  <td class="column-c">
                    <div class="d-flex">
                      <div>
                        <a
                          @click="fnGoEditCar(row.id)"
                          v-b-tooltip.hover
                          title="Update car"
                          class="d-inline pr-2"
                          ><i class="far fa-edit text-primary fs-1000"></i
                        ></a>
                      </div>
                    </div>
                  </td>
                </tr>
                <!-- Expandable section -->
                <tr v-if="opened.includes(index)">
                  <td colspan="12">
                    <div class="row mr-2 ml-2">
                      <div class="col-lg-6 col-md-6 col-12">
                        <dl class="row">
                          <dt class="col-sm-3">Sec. Description</dt>
                          <dd class="col-sm-9">
                            {{ row.secondaryCarDescription }}
                          </dd>
                          <dt class="col-sm-3">Vehicle Warranty</dt>
                          <dd class="col-sm-9">
                            {{ row.vehicleWarranty }}
                          </dd>
                          <dt class="col-sm-3">Battery Warranty</dt>
                          <dd class="col-sm-9">
                            {{ row.batteryWarranty }}
                          </dd>
                        </dl>
                      </div>

                      <div class="col-lg-6 col-md-6 col-12">
                        <div class="row">
                          <div class="col-lg-6 col-12">
                            <p class="mb-0">Featured image</p>
                            <wdImageAvatarPreview
                              :coverImgUrl="row.featuredImage"
                              :fontAwClass="'las la-image'"
                            ></wdImageAvatarPreview>
                          </div>

                          <div class="col-lg-6 col-12">
                            <p class="mb-0">Call to actionImage image</p>
                            <wdImageAvatarPreview
                              :coverImgUrl="row.callToActionImage"
                              :fontAwClass="'las la-sticky-note'"
                            ></wdImageAvatarPreview>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>

              <!-- Pagination -->
              <tr>
                <td colspan="12">
                  <div class="sits-pagination-row">
                    <div class="items-per-page">
                      <div class="pr-2">
                        <p class="mb-0">Items per page</p>
                      </div>
                      <div class="pr-5">
                        <select
                          v-model="recordsPerPage"
                          class="form-control sits_select"
                          @change="fnRecordsPerPage()"
                        >
                          <option value="10">10</option>
                          <option value="15">15</option>
                          <option value="20">20</option>
                          <option value="30">30</option>
                          <option value="40">40</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </div>
                    </div>

                    <div>
                      <pagination
                        :limit="5"
                        :data="getAdminLeadsPaginateData"
                        @pagination-change-page="fnGetCarsList"
                      ></pagination>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import pagination from 'laravel-vue-pagination'
import wdImageAvatarPreview from '../../../components/wd/WDImageAvatarPreview.vue'

export default {
  name: 'adminLeadsList',
  components: {
    pagination,
    wdImageAvatarPreview
  },
  data() {
    return {
      isDataFetch: true,
      opened: [],
      quoteList: {},
      recordsPerPage: 15,
      page: 1,
      q: '',
      selectedStatus: '',
      sort_direction: 'desc',
      sort_field: 'id',
      quoteCalculation: {},
      paginate: {
        page: 1,
        recordsPerPage: 15,
        q: '',
        selectedStatus: '',
        sort_direction: 'desc',
        sort_field: 'id'
      }
    }
  },
  computed: {
    ...mapGetters([
      'getLeadsSingle',
      'getAdminLeadsPaginateData',
      'getAdminLeadsPaginate',
      'getReferralPartnerDropdownList',

      'getCarsSingle',
      'getCarsPaginate',
      'getCarsPaginateData'
    ])
  },
  methods: {
    ...mapActions([
      'fetchLeadsSingle',
      'fetchAdminLeadsPaginate',
      'fetchReferralPartnerDropdownList',

      'fetchCarsSingle',
      'fetchCarsPaginate'
    ]),

    fnGoNewCars() {
      this.$router.push({ name: 'admin.carsNew' })
    },

    toggle(id) {
      const index = this.opened.indexOf(id)
      if (index > -1) {
        this.opened.splice(index, 1)
      } else {
        this.opened.push(id)
      }
    },

    fnGoEditCar(id) {
      this.$router.push({ name: 'admin.carsEdit', params: { id: id } })
    },

    fnGetCarsList: async function (page = 1) {
      let obj1 = this.paginate
      let obj2 = {
        page: page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchAdminLeadsPaginate(objNew)
    },

    fnRecordsPerPage() {
      let obj1 = this.paginate
      let obj2 = {
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }

      this.fetchCarsPaginate(objNew)
    },

    fnSearch() {
      let obj1 = this.paginate
      let obj2 = {
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchCarsPaginate(objNew)
    },

    fnChangeSort(field) {
      if (this.sort_field == field) {
        this.sort_direction = this.sort_direction == 'asc' ? 'desc' : 'asc'
      } else {
        this.sort_field = field
      }
      let obj1 = this.paginate
      let obj2 = {
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchCarsPaginate(objNew)
    },

    fnClear() {
      this.q = ''
      this.selectedStatus = ''
      let obj1 = this.paginate
      let obj2 = {
        page: 1,
        recordsPerPage: 15,
        q: '',
        selectedStatus: '',
        sort_direction: 'desc',
        sort_field: 'id'
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchAdminLeadsPaginate(objNew)
    }
  },
  async mounted() {
    this.isDataFetch = true
    let obj1 = this.paginate
    let obj2 = {
      page: 1,
      recordsPerPage: 15,
      q: '',
      selectedStatus: '',
      sort_direction: 'desc',
      sort_field: 'id'
    }
    let objNew = { ...obj1, ...obj2 }
    await this.fetchCarsPaginate(objNew)
    this.isDataFetch = false
  }
}
</script>

<style lang="scss" scoped>
.search-row {
  display: flex;
  // justify-content: space-between;
  gap: 20px;
  .search-box {
    width: 450px;
  }
  .status-box {
    width: 250px;
  }

  .item {
    align-self: center;
  }
}

.sits-pagination-row {
  display: flex;
  gap: 10px;
  align-items: baseline;
  padding-top: 5px;
  padding-bottom: 5px;

  .items-per-page {
    display: flex;
    align-items: baseline;
  }

  ul.pagination {
    margin-bottom: 0;
  }

  .page-item.active .page-link {
    z-index: 3;
    color: #fff;
    background-color: red;
    border-color: red;
  }
}
</style>
